<div class="flex flex-col gap-2 sm:flex-row">
  @if (position === 'left') {
    <div class="flex items-center">
      <ng-content></ng-content>
    </div>
  }

  <input
    type="color"
    [(ngModel)]="color"
    class="w-12 h-8 rounded border border-gray-300 cursor-pointer"
  />

  @if (position === 'right') {
    <div class="flex items-center">
      <ng-content></ng-content>
    </div>
  }
</div>
